<div class="component-container installer-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <app-section-header
      [title]="'personal-data.form-details.responsible-installer-title' | translate"
      [tooltip]="'tooltips.personal-data.responsible-installer' | translate"
      [showTooltip]="infoBubblesData?.showResponsibleInstallerHeaderInfo"></app-section-header>
  </div>

  <form [formGroup]="installerFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
    <div *ngIf="formSubSections.power">
      <div class="installation-type-heading">{{ 'personal-data.power' | translate }}</div>
      <app-company-data [companyDataFG]="installerFG.controls.power" [isReadOnly]="isReadOnlyPowerData"></app-company-data>
    </div>

    <div *ngIf="formSubSections.gas">
      <div class="installation-type-heading">{{ 'personal-data.gas' | translate }}</div>
      <app-company-data [companyDataFG]="installerFG.controls.gas" [isReadOnly]="isReadOnly"></app-company-data>
    </div>

    <!-- <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows checkbox-row" *ngIf="formSubSections.gas">
      <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
        <label class="ui-g-4"></label>
        <p-checkbox appEnterClick binary="true" class="installer-checkbox"
            (onChange)="addControlsForWater($event)"
                    formControlName="installerCheckbox" id="personal-data-installer-check"
                    label="{{'personal-data.form-details.fields.gas-water-installer-checkbox' | translate}}"></p-checkbox>
      </div>
    </div>
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="installerFG.value.installerCheckbox">
      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
        <label class="ui-g-7 field-label text-right-align"
             for="company-name">{{'personal-data.form-details.fields.company-name' | translate}}</label>
        <input class="ui-input pInputText small-field-width" formControlName="companyNameForWater" id="company-name-for-water"
             maxlength="25"
             pInputText size="30" type="text">
      </div>

      <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
        <label class="ui-g-7 field-label text-right-align"
             for="telephone-number">{{'personal-data.form-details.fields.telephone-number' | translate}}</label>
        <input class="ui-input pInputText small-field-width" formControlName="telephoneNumberForWater" id="telephone-number-for-water"
             maxlength="25"
             pInputText size="30" appNumber="true">
      </div>
    </div> -->

    <div *ngIf="formSubSections.water">
      <div class="installation-type-heading">{{ 'personal-data.water' | translate }}</div>
      <app-company-data [companyDataFG]="installerFG.controls.water" [isReadOnly]="isReadOnly"></app-company-data>
    </div>

    <div *ngIf="formSubSections.heating">
      <div class="installation-type-heading">{{ 'personal-data.heating' | translate }}</div>
      <app-company-data [companyDataFG]="installerFG.controls.heating" [isReadOnly]="isReadOnly"></app-company-data>
    </div>
  </form>
</div>
